import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Home from '../views/Home.vue'
import Upload from '../views/Upload.vue'
import Result from '../views/Result.vue'
import Share from '../views/Share.vue'
import { updateShare } from '../../lib/wxShare'
// import { updateShare } from '../../lib/tencentShare'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/upload',
    name: 'upload',
    component: Upload
  },
  {
    path: '/result',
    name: 'result',
    component: Result
  },
  {
    path: '/share',
    name: 'share',
    component: Share
  }
]

const router = new VueRouter({
  // mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  // if (!store.state.jsUrl) {
  //   // 记录第一次进入的URL
  //   store.commit('setWxJsUrl', document.URL)
  // }
  // console.log(to, from)

  if (to.name === 'home') {
    history.replaceState(history.state, '', location.pathname + '#/')
  }
  if (to.name === 'upload') {
    // history.replaceState(history.state, '', location.pathname + '#/')
  }
  if (to.name === 'result') {
    history.replaceState(history.state, '', location.pathname + '?shareId=' + store.state.shareId + '#/result')
  }
  if (to.name === 'share') {
    history.replaceState(history.state, '', location.pathname + '?shareId=' + store.state.shareId + '#/result')
  }

  // 重置网页链接，并清空分享数据
  // let url = window.location.href
  // window.location.href = url
  updateShare({
    title: store.state.shareData.title,
    desc: store.state.shareData.desc,
    link: window.location.href
  })
  // if (to.name === 'share') history.replaceState(history.state, '', location.pathname + '?shareId=' + store.state.shareId + '#/share')
  next()
})

// 路由守卫，页面切换后
router.afterEach((to, from) => {
  // console.log(to, from)
})

export default router
